import React, { useState, useEffect } from 'react'
import { Box } from '../../styles.style'
import { MaskCep } from '../masks/masks'
import { MuvicardService } from '../../../../services/muvicard.service'

const Cep = ({
	handleBlur,
	handleChange,
	errors,
	touched,
	nextStep,
	values,
	setFieldValue,
	userData,
	updateUserData,
	hideLoading
}) => {
	const [cep, setCep] = useState('')

	function Cep(e) {
		setCep(MaskCep(e.target.value))
	}

	function handleNextStep() {
		let newUserData = { ...userData }
		newUserData.zipCode = cep
		newUserData.address.zipCode = cep
		updateUserData(newUserData)
		nextStep()
	}

	useEffect(() => {
		if (userData) {
			hideLoading()
			const { address } = userData
			if (address) {
				const { zipCode } = address
				if (zipCode) {
					setCep(MaskCep(address.zipCode))
					setFieldValue('zipCode', address.zipCode)
				}
			}
		}
		MuvicardService.proposalStepRegister('CEP', 'Acesso')
	}, [userData])

	return (
		<Box className="box-cep">
			<div className="field">
				<header>
					<h5>Por favor, digite seu CEP</h5>
				</header>

				<div>
					<input
						autoFocus
						className={
							errors.zipCode ? 'field-error input-big' : 'input-big'
						}
						type="text"
						placeholder="CEP"
						id="zipCode"
						maxLength="9"
						name="zipCode"
						value={cep || values.zipCode}
						onBlur={handleBlur}
						onChange={e => {
							Cep(e)
							handleChange(e)
						}}
					/>
					<div className={'msg-error'}>{errors.zipCode}</div>
					<div>
						<a
							title="Não sei meu CEP"
							href="http://www.buscacep.correios.com.br/sistemas/buscacep/"
							target="_blank"
							className="no-cep">
							Não sei meu CEP
						</a>
					</div>
				</div>
			</div>
			<button
				disabled={!values.zipCode || (errors.zipCode && touched.zipCode)}
				className={
					errors.zipCode && touched.zipCode ? 'disabled button' : 'button'
				}
				type="button"
				onClick={handleNextStep}>
				Próximo
			</button>
		</Box>
	)
}

export default Cep
